import { Res } from '../types/service';
import { IColumnMetaData } from '../types';
import { DateCell, LinkCell, ProgressCell, TagCell } from '../modules/VehiclesGrid/GridCellRenderers';
import request from './HttpService';
import { ENDPOINTS, META_DATA_MODULES, META_DATA_SUB_MODULES } from '../utils/constants';
import { MetaData } from '../types/metaData';
import { Inventory, ISearchCustomer } from '../types/inventory';
import { GetAssignmentRes, TAssignmentStatus } from '../types/assignments';

interface Props {
  method: 'GET' | 'POST' | 'DELETE' | 'PUT' | 'PATCH';
  data?: any;
  params?: object;
  url?: string;
}

export const getMetaData = async (module: string, subModule: string): Promise<MetaData> => {
  const response = await request.get(ENDPOINTS.metaData, {
    params: {
      module,
      subModule,
    },
  });
  return response.data.data[0];
};

export const CellTypes = {
  Link: LinkCell,
  Tag: TagCell,
  Date: DateCell,
  ProgressBar: ProgressCell,
  Plain: undefined,
};

export const getColDefs = async () => {
  const response = await getMetaData(META_DATA_MODULES.vehicles, META_DATA_SUB_MODULES.vehiclesGrid);
  const colMetaDataList: IColumnMetaData[] = response?.columnDetails;

  return colMetaDataList.map((colMetaData) => {
    const colDef: any = { field: colMetaData.property, headerName: colMetaData.propertyName };
    colDef.width = colMetaData.width;
    colDef.filter = colMetaData.filterType;
    colDef.type = colMetaData.type;
    return colDef;
  });
};

export interface TGetAssignmentParam {
  requestor?: string;
  status?: TAssignmentStatus;
  fromDate?: string;
  toDate?: string;
  // perPage: number;
  // page: number;
  // sortStatus?: boolean;
  // sort?: any;
}
export const getAssignments = async (params: TGetAssignmentParam) => {
  const response = await request.post<Res<GetAssignmentRes[]>>(ENDPOINTS.getAssignments, {
    params,
  });
  return response.data.data;
};

export const getApprovedOrRejectedAssignments = async (
  status: string,
  perPage: number,
  page: number,
  sortStatus?: boolean,
  sort?: any,
  filterText?: any,
  grouping?: any,
  groupKeys?: any,
  filterKeys?: any
) => {
  try {
    if (filterKeys?.length > 0) {
      filterKeys = filterKeys.join('|');
    }
    const response = await request.post(
      ENDPOINTS.getApprovedOrRejectedAssignments(status, perPage, page, sortStatus, sort, grouping, groupKeys),
      {
        searchText: filterText.toString(),
        filter: filterKeys
          .toString()
          .replace(/inventoryVehicle./gi, 'inventoryVehicle_')
          .replace(/customerVehicle./gi, 'customerVehicle_'),
      }
    );
    return response.data || [];
  } catch (err) {
    console.log(err);
    return { data: [] };
  }
};

export const getUnAssignedOrders = async (params: Record<string, any>) => {
  const response = await request.get<Res<any[]>>(ENDPOINTS.getUnAssignedOrders, {
    params,
  });

  return response.data.data;
};

interface PCreateAssignment {
  assignmentType: string;
  comments: string;
  requestor: string;
  orderNumber?: string;
  invBatchNumber: string;
  directApproval: boolean;
}

interface PRequestAssignment {
  orderId: string;
  requestor: string;
  requestId: string;
  reason: string;
}

interface PCancelAssignment {
  requestId: string;
  requestor: string;
  reason: string;
}

export const createAssignment = async (data: PCreateAssignment) => {
  const response = await request.post(ENDPOINTS.createAssignment, data);
  return response.data;
};

export const requestAssignment = async (data: PRequestAssignment) => {
  const response = await request.post(ENDPOINTS.requestAssignment, data);
  return response.data;
};

export const cancelAssignment = async (data: PCancelAssignment) => {
  const response = await request.put<Res<null>>(ENDPOINTS.cancelAssignment, data);
  return response.data;
};

export const rejectAssignment = async (data: { requestId: string; reason: string; requestor: string }) => {
  const response = await request.put<Res<null>>(ENDPOINTS.rejectAssignment, data);
  return response.data;
};

export const approveAssignment = async (requestId: string, requestor: string, retry?: boolean) => {
  const response = await request.put(ENDPOINTS.approveAssignment, { requestId, requestor, retry });
  return response.data;
};

export const retryOnHoldAssignment = async (requestId: string, requestor: string, retry: boolean) => {
  const response = await request.post(ENDPOINTS.retryOnHoldAssignment, { requestId, requestor, retry });
  return response.data;
};

export const getAssignmentFilterValues = async (status: string, fieldName: string) => {
  fieldName = fieldName.replace('.', '_');
  try {
    return (await request.post(ENDPOINTS.getAssignmentFilterValues(status, fieldName))).data || [];
  } catch (err) {
    return { data: [] };
  }
};
